import React, {Dispatch, SetStateAction, useCallback, useContext, useRef, useState} from "react"
import Slider from "../slider/Slider"
import {useRouter} from "next/router"
import {filterUrl} from "./FilterUrl"
import {CollectionName} from "../../constants"
import DataContext from "../../context/DataContext"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import {priceRangeDelimiter} from "./Config"

type Props = {
    param: string
    shouldUseZero?: boolean
    value: Item
    setValue: Dispatch<SetStateAction<Item | null>>
    collectionName:CollectionName
}
type Item = {
	slug: string,
	name: string
	min: number
	max: number
	value:number[]
}
function ReusableRangeFilter({param, value, setValue, collectionName}: Props) {
	const prevValue = useRef<Item>(value)
	const router = useRouter()
	const {t} = useTranslation()
	const [firstInput, setFirstInput] = useState<any>(value?.value?.[0])
	const [secondInput, setSecondInput] = useState<any>(value?.value?.[1])
	const {brandWorld} = useContext(DataContext)
	const isBrandWorld = router.pathname.includes("/brand-world")
	const defaultValue:string = router.query?.[param] as string
	const setDefaut = useCallback(() => setValue(prev => {
		prev.value = [Number(defaultValue?.split(priceRangeDelimiter)[0]) || value?.min, Number(defaultValue?.split(priceRangeDelimiter)[1]) || value?.max]
		return prev
	}), [defaultValue])
	setDefaut()

	const resetFilter = () => {
		const query = Object.entries(router.query).filter(([key, value]) => key !== param)
		const url = isBrandWorld ? `${filterUrl({...query}, null, null, CollectionName.BrandWorld, CollectionName.BrandWorld, brandWorld.brandSlug)}#products-listing` : `${filterUrl({...query}, null, null, collectionName, collectionName)}`

		router.push(url, undefined, {shallow: true, scroll: false})
	}

	const setRangeValue = valueArray => {
		if (valueArray?.[0] <= value.min && valueArray?.[1] >= value.max) {
			resetFilter()
			return null
		}

		const url = isBrandWorld ? `${filterUrl({...router.query, [param]: valueArray?.join(priceRangeDelimiter)}, param, valueArray?.join(priceRangeDelimiter), CollectionName.BrandWorld, CollectionName.BrandWorld, brandWorld.brandSlug)}#products-listing` : `${filterUrl({...router.query, [param]: valueArray?.join(priceRangeDelimiter)}, param, valueArray?.join(priceRangeDelimiter), collectionName, collectionName)}`
		setFirstInput(valueArray[0])
		setSecondInput(valueArray[1])
		setValue(previous => {
			prevValue.current = previous
			previous.value = valueArray

			return previous
		})

		router.push(url, undefined, {shallow: true, scroll: false})
	}

	const firstInputRef = useRef(null)
	const secondInputRef = useRef(null)

	const handleFirstInputChange = () => {
		const valueMin = parseInt(firstInputRef?.current?.value, 10)

		setFirstInput(valueMin)
	}

	const handleSecondInputChange = () => {
		const valueMax = parseInt(secondInputRef.current.value, 10)

		setSecondInput(valueMax)
	}

	return (
		<div className="position-relative price-filter-slider  py-4">
			<div className="row gx-2 mb-2  pb-1 d-flex align-items-center justify-content-between">
				<div className="col-6">
					<Typography variant="bodySm"
						semanticTag="h4"
						style={{color: "#6C7074"}}>{t("from", {ns: "filters"})}</Typography>
					<input ref={firstInputRef}
						type="number"
						className="w-100"
						value={firstInput}
						onBlur={() => {
							const valueMin = parseInt(firstInputRef?.current?.value, 10)

							setRangeValue([Number(valueMin >= secondInput ? secondInput - 30 : firstInputRef.current.value || value.min), secondInput])
						}}
						onChange={handleFirstInputChange}/>
				</div>
				<div className="col-6">
					<Typography variant="bodySm"
						semanticTag="h4"
						style={{color: "#6C7074"}}>{t("to", {ns: "filters"})}</Typography>
					<input ref={secondInputRef}
						type="number"
						className="w-100"
						onBlur={() => {
							const valueMax = parseInt(secondInputRef.current.value, 10)

							setRangeValue([firstInput, valueMax <= firstInput ? firstInput + 30 : Number(secondInputRef.current.value || value.max)])
						}}
						value={ secondInput }
						onChange={handleSecondInputChange}/>
				</div>
			</div>
			<Slider
				min={value?.min || 0}
				max={value?.max || value?.min + 1 || 1}
				hasPriceTooltip
				double
				defaultValue={value.value}
				step={1}

				onAfterChange={newValue => setRangeValue(newValue)} />
		</div>
	)
}

export default ReusableRangeFilter
